var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { dtRum } from '../dtRum';
import { getFetchEnterActionText, getFetchActionNameText } from './fetchTexts';
import { getGraphqBodyContent } from './getGraphqBodyContent';
import { getGraphqlEnterActionText, getGraphqlActionNameText } from './graphqlTexts';
var originalFetch = window.fetch;
export var fetchInterceptors = function () {
    window.fetch = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            function getEnterActionText(isGraphqlRequest) {
                return isGraphqlRequest ? getGraphqlEnterActionText(args) : getFetchEnterActionText(args);
            }
            function getActionNameText(isGraphqlRequest) {
                return isGraphqlRequest ? getGraphqlActionNameText(args) : getFetchActionNameText(args);
            }
            function fetchActions(isGraphqlRequest) {
                if (isGraphqlRequest === void 0) { isGraphqlRequest = true; }
                return __awaiter(this, void 0, void 0, function () {
                    var action, xhrAction, response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                action = dtRum === null || dtRum === void 0 ? void 0 : dtRum.enterAction(getEnterActionText(isGraphqlRequest));
                                xhrAction = dtRum === null || dtRum === void 0 ? void 0 : dtRum.enterXhrAction('xhr', 1, resource.toString());
                                dtRum === null || dtRum === void 0 ? void 0 : dtRum.actionName(getActionNameText(isGraphqlRequest), xhrAction);
                                return [4 /*yield*/, originalFetch(resource, config).catch(function (e) {
                                        dtRum === null || dtRum === void 0 ? void 0 : dtRum.markXHRFailed(500, "XHR Error: ".concat(e.message));
                                        dtRum === null || dtRum === void 0 ? void 0 : dtRum.reportError("report error: ".concat(e.message), action);
                                        return e;
                                    })];
                            case 1:
                                response = _a.sent();
                                action && (dtRum === null || dtRum === void 0 ? void 0 : dtRum.leaveAction(action));
                                xhrAction && (dtRum === null || dtRum === void 0 ? void 0 : dtRum.leaveXhrAction(xhrAction));
                                return [2 /*return*/, response];
                        }
                    });
                });
            }
            var resource, config, isGraphqlRequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource = args[0], config = args[1];
                        isGraphqlRequest = !!getGraphqBodyContent(config);
                        return [4 /*yield*/, fetchActions(isGraphqlRequest)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return function () {
        window.fetch = originalFetch;
    };
};
//# sourceMappingURL=index.js.map